import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function StyleManifesto() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="font-heading text-accent-500 text-sm tracking-[0.2em] uppercase mb-3 whitespace-nowrap">
            Style Manifesto
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            风格<span className="text-primary-600">宣言</span>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto leading-relaxed">
            五种风格，五种态度。每一种都是你内心野兽的不同面向，选择你今天的战袍。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.slug}`}
              className="group relative h-80 rounded-lg overflow-hidden"
            >
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`裙子下面是野兽风格 - ${cat.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-heading text-2xl font-bold text-background-50 mb-2">
                  {cat.name}
                </h3>
                <p className="text-background-200 text-sm leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <span className="inline-block mt-3 text-accent-400 text-xs tracking-wider uppercase opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 whitespace-nowrap">
                  探索更多 →
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看所有风格分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}